import {useSetting} from "contexts/setting";
import {useImages} from "contexts/images";
import {useBgUrl} from "hooks/useBgUrl";
import {GENERATIVE_BG_MARKERS, getLogoUrl} from "libs/logo";
import {withDeployVersion} from "libs/deployVersion";
import {LOGO_VARIANT_NONE} from "libs/logoVariantConstants";

/** The <img> src of the banner logo. It carries the deploy version (libs/deployVersion). */
export function useLogoUrl(id) {
  const {product, dataChannel, dataType, bgOption} = useSetting();
  const {logoVariants} = useImages();
  const {markers} = useBgUrl();
  const override = logoVariants?.[id];
  if (override === LOGO_VARIANT_NONE) return undefined;
  if (override) return withDeployVersion(override);
  const bgMarkers = bgOption === "generative" ? GENERATIVE_BG_MARKERS : markers;
  return withDeployVersion(getLogoUrl(product.value, bgMarkers, dataType, dataChannel));
}
